import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TextField } from '@material-ui/core';
import { TableProcessed } from '@features/inquiries/components/ProcessedInquiries/TableProcessed';
import dayjs from 'dayjs';
import { useProcessedInquiries } from '@features/inquiries/hooks/useInquiryQueries';

const useStyles = makeStyles((theme) => ({
  column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  input: {
    width: 200,
  },
}));

const TabProcessed = () => {
  const classes = useStyles();
  const [date, setDate] = useState(dayjs().subtract(7, 'day').format('YYYY-MM-DD'));
  const [timestampFrom, setTimestampFrom] = useState(
    dayjs().subtract(7, 'day').unix()
  );

  // Utilisation du hook React Query
  const { data: inquiries = [] } = useProcessedInquiries(timestampFrom);

  const handleDateChange = (event) => {
    const newDate = event.target.value;
    const newTimestamp = dayjs(newDate, "YYYY-MM-DD").unix();
    setDate(newDate);
    setTimestampFrom(newTimestamp);
  };

  return (
    <div className={classes.column}>
      <div className={classes.row}>
        <TextField
          type="date"
          id="dateFrom"
          margin="dense"
          value={date}
          variant="outlined"
          onChange={handleDateChange}
          InputLabelProps={{
            shrink: true,
          }}
          label="Requêtes depuis le"
          className={classes.input}
        />
      </div>
      <TableProcessed data={inquiries} date={date} />
    </div>
  );
};

export default TabProcessed;
